import type { GamePageContext } from "@/features/game/state";
import type { PreviewContent } from "./content/preview-content.types";
import { resolvePreviewLeague } from "./preview-league.data";
import { readPreviewResources } from "./data/read-preview-resources";
import { composePreviewContent } from "./data/compose-preview-content";
export async function previewContent({
  signal,
  slug,
  context,
  includeDetails = true,
}: {
  signal?: AbortSignal | undefined;
  slug: string;
  context?: GamePageContext | undefined;
  includeDetails?: boolean;
}): Promise<PreviewContent | null> {
  const resolved = await resolvePreviewLeague({
    signal,
    slug,
    context,
  });

  if (!resolved) return null;

  const resources = await readPreviewResources({
    signal,
    resolved,
    includeDetails,
  });
  return resources
    ? composePreviewContent({ resolved, resources, includeDetails })
    : null;
}
